
import { z } from "zod";

// Form schema for authentication
export const authSchema = z.object({
  email: z.string().email("Please enter a valid email address"),
  password: z.string().min(6, "Password must be at least 6 characters"),
  first_name: z.string().min(2, "First name must be at least 2 characters").optional(),
  last_name: z.string().min(2, "Last name must be at least 2 characters").optional(),
});

export type AuthFormData = z.infer<typeof authSchema> & {
  email: string;
  password: string;
  first_name: string;
  last_name: string;
};
